import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";

const URL_API = ApiUrl.BASE;

const RendimientoService = {

  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/rendimiento", { params });
    return respuesta.data;
  },

  async exportar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/rendimiento/exportar", {
      params: { ...params },
      responseType: "blob",
    });
    return respuesta;
  },

};

export { RendimientoService };
